<template>
  <footer>
    <p>
      <span style="color: rgba(255, 255, 255, 0.6)">{{ settings.name_line }}</span>
      <span style="margin: 0 0.5rem; color: rgba(255, 255, 255, 0.2)">•</span>
      {{ settings.title_line }}
    </p>

    <nav class="footer-legal" aria-label="روابط الموقع">
      <template v-for="(link, i) in settings.legal_links" :key="i">
        <span class="footer-legal-sep" v-if="i > 0">•</span>
        <router-link :to="link.link">{{ link.label }}</router-link>
      </template>
    </nav>

    <div class="d-flex align-items-center gap-3">
      <p>{{ settings.credit_text }}</p>
      <ul class="social">
        <li v-for="(social, i) in settings.socials" :key="i">
          <a :href="social.url" target="_blank" :aria-label="social.icon">
            <i class="pi" :class="socialIconClass[social.icon] || 'pi-globe'"></i>
          </a>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
import { computed } from "vue";
import { useHomepageConfig } from "@/composables/useHomepageConfig";

const DEFAULT_FOOTER_SETTINGS = {
  name_line: "أ/ مصطفى حسني",
  title_line: "مدرس الكيمياء",
  legal_links: [
    { label: "من نحن", link: "/about" },
    { label: "المدونة", link: "/blogs" },
    { label: "سياسة الخصوصية", link: "/privacy-policy" },
    { label: "شروط الاستخدام", link: "/terms-of-service" },
  ],
  credit_text: "Powered by Ahmed Hawam ⚡",
  socials: [
    { icon: "facebook", url: "https://facebook.com/ahmedhawam2030" },
    { icon: "whatsapp", url: "https://wa.me/+201008430711" },
    { icon: "phone", url: "tel:01008430711" },
  ],
};

const SOCIAL_ICON_CLASS = {
  facebook: "pi-facebook",
  whatsapp: "pi-whatsapp",
  phone: "pi-phone",
};

export default {
  name: "AppFooter",
  setup() {
    const { getSettings, fetchHomepageConfig } = useHomepageConfig();
    fetchHomepageConfig();
    const settings = computed(() => getSettings("footer", DEFAULT_FOOTER_SETTINGS));
    return { settings, socialIconClass: SOCIAL_ICON_CLASS };
  },
};
</script>

<style scoped>
.footer-legal {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;
  font-family: 'Cairo', sans-serif;
  font-size: 0.85rem;
}
.footer-legal a {
  color: rgba(255, 255, 255, 0.72);
  text-decoration: none;
  font-weight: 700;
  transition: color 0.2s;
}
.footer-legal a:hover { color: #fff; }
.footer-legal-sep { color: rgba(255, 255, 255, 0.25); }
</style>
